import React, { Component } from 'react';
import { connect } from 'react-redux';
// New portal imports
import CardWrapper from '../../../dashboardNew/components/CardWrapper';
import IntroBanner from '../../../dashboardNew/components/IntroBanner';
import BannerAdverts from '../../../dashboardNew/components/BannerAdverts';
import { PrismicDocumentHelper } from '../../../../helpers/prismicHelpers/PrismicHelpers';

// Data
import { BannerListHelper } from '../../../../helpers/prismicHelpers/prismic-custom-helpers/HomepageCardHelpers';

class ITNHomepage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			introBanner: null,
			cards: null,
			bannerData: [],
      sidebar: ''
		};
	}

	componentWillMount() {
		this.getAllSlices();
		this.getBanners();
        

            this.breakpoint = window.matchMedia(
                '(max-width: 768px)'
              );
    
              const breakpointHandler = () => {
                this.setState({ sidebar: this.breakpoint.matches });
              };
    
              this.breakpoint.addListener(breakpointHandler);
                breakpointHandler();
	}

	async componentDidMount() {
		// window.scrollTo(0, 0);
	}

	async getBanners(){
		const data = await PrismicDocumentHelper('my.banners.uid', 'homepage-banners', false, 'at')
		const bannerData = BannerListHelper(data);
		this.setState({ bannerData: bannerData.bannersList });
	}

	async getAllSlices() {
		// getting all slices on the itn homepage in prismic and seperating the cards from the banner so that the banner never changes place on the page.
		const data = await PrismicDocumentHelper('my.flexible-layout.uid', 'itn-homepage', false, 'at' );
		let resultsArray = data.result[0].data.body;
		let banner = [];
		let cards = [];
		resultsArray.map(item => {
			if (item.slice_type === 'hero_-_header') {
				banner.push(item);
			} else {
				cards.push(item);
			}
		});
		this.setState({
			introBanner: banner[0],
			cards: cards,
		});
	}

	// function to return card wrapper

	card(i, type, alt) {
		return (
			<CardWrapper
				key={i}
				cardWrapperHeading={type.primary.card_heading}
				cardWrapperCta={type.primary.card_path}
				altStyle={alt}
				cardTypeProps={type.primary.card_heading}
				cards={type.items}
				type={type.slice_type}
			/>
		);
	}

	bannerSections(alt, count) {
		if( Array.isArray(this.state.bannerData) ){
		
			return this.state.bannerData.map((banner, i) => {
				if (i === count - 1) {
					return (
						<BannerAdverts
							key={i}
							image={banner.image}
							heading={banner.heading}
							bodyCopy={banner.bodyCopy}
							altStyle={alt}
							ctaCopy={banner.ctaCopy}
							ctaLink={banner.ctaLink}
						/>
					);
				}
			});
		}
	}

	render() {
		const { cards, introBanner } = this.state;
        let mod = 0;

		return (
			<div className="portal-page-wrapper">
				{introBanner && (
					<IntroBanner
						topOfPageAnimation={true}
						introBannerImage={introBanner.primary.background_image.url}
						introBannerHeading={introBanner.primary.headline[0].text}
						introBannerCopy={introBanner.primary.subtitle[0].text}
						introBannerCtaLink={introBanner.items[0].button_link[0].text}
						introBannerCtaCopy={introBanner.items[0].button_text[0].text}
						typeOfLink={introBanner.items[0].button_type}
					/>
				)}

				{cards &&
					cards.map((type, i) => {
						// mapping over each slice of cards from prismic and returning a card wrapper for each one with the individual cards being passed down as props
						var index = mod + i;
						if (i % 2) {
							// every other card will have a banner underneath, the mod and index are to monitor the alt styles for each one so that the banners also have alt style
							const card = this.card(index, type, !!(index % 2));
							mod++;
							index++;
							return (
								<React.Fragment key={card.key}>
									{card}
									{ this.bannerSections(!!(index % 2), mod) }
								</React.Fragment>
							);
						} else {
							return this.card(index, type, !!(index % 2));
						}
					})}
			</div>
		);
	}
}

ITNHomepage.propTypes = {};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ITNHomepage);



// WEBPACK FOOTER //
// src/client/components/site/features/homepage/ITNHomepage.js